module.exports = __webpack_public_path__ + "img/VerSubMenu.26bbb884.png";